import api from '@pray/shared/utils/api';
import { ObjectResponse } from '@pray/shared/utils/api/types/response';

type DeleteArtistDomainProps = {
  artistId: string;
  artistDomainId: string;
};

type DeleteArtistDomainResponse = {
  success: boolean;
  message?: string;
};

export const deleteArtistDomain = async ({ artistId, artistDomainId }: DeleteArtistDomainProps) => {
  if (!artistId) throw Error('Artist ID is required');
  if (!artistDomainId) throw Error('Artist domain ID is required');

  const url = `/web/studio/artists/${artistId}/emails/domains/${artistDomainId}`;

  const response = await api.executeDeleteRequest<ObjectResponse<DeleteArtistDomainResponse>>(url);

  return response.data;
};
